import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DTOEntitiesComponent } from './components/dto-entities/dto-entities.component'
import { DateFilterComponent } from './components/dynamic-table/filters/date-filter/date-filter.component'
import { FloatFilterComponent } from './components/dynamic-table/filters/float-filter/float-filter.component'
import { AddressCellComponent } from './components/dynamic-table/inline-edit-cells/address-cell/address-cell.component'
import { BoolCellComponent } from './components/dynamic-table/inline-edit-cells/bool-cell/bool-cell.component'
import { CalendarWeekCellComponent } from './components/dynamic-table/inline-edit-cells/calendar-week-cell/calendar-week-cell.component'
import { ColorCellComponent } from './components/dynamic-table/inline-edit-cells/color-cell/color-cell.component'
import { CurrencyCellComponent } from './components/dynamic-table/inline-edit-cells/currency-cell/currency-cell.component'
import { DateCellComponent } from './components/dynamic-table/inline-edit-cells/date-cell/date-cell.component'
import { DatePeriodCellComponent } from './components/dynamic-table/inline-edit-cells/date-period-cell/date-period-cell.component'
import { EntityReferenceCellComponent } from './components/dynamic-table/inline-edit-cells/entity-reference-cell/entity-reference-cell.component'
import { FloatCellComponent } from './components/dynamic-table/inline-edit-cells/float-cell/float-cell.component'
import { FsmCellComponent } from './components/dynamic-table/inline-edit-cells/fsm-cell/fsm-cell.component'
import { IconCellComponent } from './components/dynamic-table/inline-edit-cells/icon-cell/icon-cell.component'
import { IconPickerCellComponent } from './components/dynamic-table/inline-edit-cells/icon-picker-cell/icon-picker-cell.component'
import { IntegerCellComponent } from './components/dynamic-table/inline-edit-cells/integer-cell/integer-cell.component'
import { JsonCellComponent } from './components/dynamic-table/inline-edit-cells/json-cell/json-cell.component'
import { MultilineCellComponent } from './components/dynamic-table/inline-edit-cells/multiline-cell/multiline-cell.component'
import { PythonCellComponent } from './components/dynamic-table/inline-edit-cells/python-cell/python-cell.component'
import { StringCellComponent } from './components/dynamic-table/inline-edit-cells/string-cell/string-cell.component'
import { CronCellComponent } from './components/dynamic-table/inline-edit-cells/cron-cell/cron-cell.component'
import { DynamicTableComponent } from './components/dynamic-table/dynamic-table.component'
import { EntityActionsComponent } from './components/entity-attachments/entity-actions/entity-actions.component'
import { EntityAttributesComponent } from './components/entity-attachments/entity-attributes/entity-attributes.component'
import { EntityFieldGroupComponent } from './components/entity-attachments/entity-field-group/entity-field-group.component'
import { EntityFileAttachmentsComponent } from './components/entity-attachments/entity-file-attachments/entity-file-attachments.component'
import { EntityGenericAttachmentsComponent } from './components/entity-attachments/entity-generic-attachments/entity-generic-attachments.component'
import { EntityGroupRelationComponent } from './components/entity-attachments/entity-group-relation/entity-group-relation.component'
import { EntityHeaderComponent } from './components/entity-attachments/entity-header/entity-header.component'
import { EntityNameComponent } from './components/entity-attachments/entity-name/entity-name.component'
import { EntityNotesComponent } from './components/entity-attachments/entity-notes/entity-notes.component'
import { EntityQuickNotesComponent } from './components/entity-attachments/entity-quick-notes/entity-quick-notes.component'
import { EntitySubtypesComponent } from './components/entity-attachments/entity-subtypes/entity-subtypes.component'
import { EntityDialogComponent } from './components/entity-dialog/entity-dialog.component'
import { EntityDropdownComponent } from './components/entity-dropdown/entity-dropdown.component'
import { EntityTileComponent } from './components/entity-tile/entity-tile.component'
import { EntityViewComponent } from './components/entity-view/entity-view.component'
import { TabContainerComponent } from './components/entity-view/tab-container/tab-container.component'
import { SelectEntityComponent } from './components/select-entity/select-entity.component'
import { CardModule } from 'primeng/card'
import { PermissionsModule } from '../permissions/permissions.module'
import { TableModule } from 'primeng/table'
import { PickListModule } from 'primeng/picklist'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TooltipModule } from 'primeng/tooltip'
import { DialogModule } from 'primeng/dialog'
import { ButtonModule } from 'primeng/button'
import { RouterModule } from '@angular/router'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { MultiSelectModule } from 'primeng/multiselect'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { CalendarModule } from 'primeng/calendar'
import { InputTextModule } from 'primeng/inputtext'
import { AddressControlComponent } from './controls/address-control/address-control.component'
import { FsmControlComponent } from './controls/fsm-control/fsm-control.component'
import { IconControlComponent } from './controls/icon-control/icon-control.component'
import { SelectListComponent } from './controls/select-list/select-list.component'
import { DropdownModule } from 'primeng/dropdown'
import { CheckboxModule } from 'primeng/checkbox'
import { PanelModule } from 'primeng/panel'
import { TabViewModule } from 'primeng/tabview'
import { EditorModule } from 'primeng/editor'
import { TileDashletComponent } from './components/entity-attachments/dashlets/tile-dashlet/tile-dashlet.component'
import { ButtonDashletComponent } from './components/entity-attachments/dashlets/button-dashlet/button-dashlet.component'
import { ChartDashletComponent } from './components/entity-attachments/dashlets/chart-dashlet/chart-dashlet.component'
import { ChartModule } from 'primeng/chart'
import { FileUploadModule } from 'primeng/fileupload'
import { FileSaverModule } from 'ngx-filesaver'
import { DirectivesModule } from '../directives/directives.module'
import { IconPickerModule } from 'ngx-icon-picker'
import { InitCallbackDirective } from './components/dynamic-table/init-callback.directive'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { MiscModule } from '../misc/misc.module'
import { ColorPickerModule } from 'primeng/colorpicker'
import { LogDashletComponent } from './components/entity-attachments/dashlets/log-dashlet/log-dashlet.component'
import { PasswordCellComponent } from './components/dynamic-table/inline-edit-cells/password-cell/password-cell.component'
import { InputNumberModule } from 'primeng/inputnumber'
import { CurrencyControlComponent } from './components/entity-dialog/controls/currency-control/currency-control.component'
import { CronEditorComponent } from './controls/cron-editor/cron-editor.component'
import { RadioButtonModule } from 'primeng/radiobutton'
import { CronEditorDialogComponent } from './components/cron-editor-dialog/cron-editor-dialog.component'
import { DtoActionsComponent } from './components/dto-actions/dto-actions.component'
import { DirectBoolCellComponent } from './components/dynamic-table/inline-edit-cells/direct-bool-cell/direct-bool-cell.component'
import { GroupCellComponent } from './components/dynamic-table/inline-edit-cells/group-cell/group-cell.component'
import { FieldsFilterComponent } from './components/entity-attachments/fields-filter/fields-filter.component'
import { FieldsViewComponent } from './components/entity-attachments/fields-view/fields-view.component'
import { EditComponentsModule } from '../../components/edit-components/edit-components.module'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { WizardComponent } from '../wizard/components/wizard.component'
import { WizardDropDownComponent } from '../wizard/custom-inputs/wizard-drop-down/wizard-drop-down.component'
import { GenericDropDownComponent } from '../../components/edit-components/generic-drop-down/generic-drop-down.component'
import { DropdownCellComponent } from './components/dynamic-table/inline-edit-cells/dropdown-cell/dropdown-cell.component'
import { SelectionFilterComponent } from './components/dynamic-table/filters/selection-filter/selection-filter.component'
import { CodeWrapperComponentHTML } from '../misc/components/code-editor/code-wrapper/code-wrapper.component'
import { IntervalCellComponent } from './components/dynamic-table/inline-edit-cells/interval-cell/interval-cell.component'
import { IntervalControlComponent } from './controls/interval-control/interval-control.component'
import { DropDownWrapperComponent } from './components/dynamic-table/inline-edit-cells/drop-down-wrapper/drop-down-wrapper.component'
import { EntityReferenceInputComponent } from '../wizard/custom-inputs/entity-reference-input/entity-reference-input.component'
import { OverlayComponent } from './components/overlay/overlay.component'
import { DtoTypeCellComponent } from './components/dynamic-table/inline-edit-cells/dtotype-cell/dtotype-cell.component'
import { ColHeaderComponent } from './components/dynamic-table/col-header/col-header.component'
import { FieldsetModule } from 'primeng/fieldset'
import { MultilineEditorComponent } from '../wizard/custom-inputs/multiline-editor/multiline-editor.component'
import { ToggleButtonModule } from 'primeng/togglebutton'
import { MultiselectCellComponent } from './components/dynamic-table/inline-edit-cells/multiselect-cell/multiselect-cell.component'
import { MultiselectWrapperComponent } from './components/dynamic-table/inline-edit-cells/multiselect-wrapper/multiselect-wrapper.component'
import { GridInputComponent } from '../wizard/custom-inputs/grid-input/grid-input.component'

@NgModule({
  declarations: [
    DTOEntitiesComponent,
    DateFilterComponent,
    FloatFilterComponent,
    AddressCellComponent,
    BoolCellComponent,
    DirectBoolCellComponent,
    CalendarWeekCellComponent,
    ColorCellComponent,
    CurrencyCellComponent,
    DateCellComponent,
    DatePeriodCellComponent,
    EntityReferenceCellComponent,
    FloatCellComponent,
    FsmCellComponent,
    IconCellComponent,
    IconPickerCellComponent,
    IntegerCellComponent,
    JsonCellComponent,
    MultilineCellComponent,
    PythonCellComponent,
    StringCellComponent,
    PasswordCellComponent,
    CronCellComponent,
    DynamicTableComponent,
    EntityActionsComponent,
    EntityAttributesComponent,
    EntityFieldGroupComponent,
    EntityFileAttachmentsComponent,
    EntityGenericAttachmentsComponent,
    EntityGroupRelationComponent,
    EntityHeaderComponent,
    EntityNameComponent,
    EntityNotesComponent,
    EntityQuickNotesComponent,
    EntitySubtypesComponent,
    EntityDialogComponent,
    EntityDropdownComponent,
    EntityTileComponent,
    EntityViewComponent,
    SelectEntityComponent,
    AddressControlComponent,
    FsmControlComponent,
    IconControlComponent,
    SelectListComponent,
    TileDashletComponent,
    ButtonDashletComponent,
    InitCallbackDirective,
    ChartDashletComponent,
    LogDashletComponent,
    CurrencyControlComponent,
    CronEditorComponent,
    CronEditorDialogComponent,
    DtoActionsComponent,
    GroupCellComponent,
    FieldsFilterComponent,
    FieldsViewComponent,
    WizardComponent,
    WizardDropDownComponent,
    MultilineEditorComponent,
    GenericDropDownComponent,
    DropdownCellComponent,
    SelectionFilterComponent,
    CodeWrapperComponentHTML,
    IntervalCellComponent,
    IntervalControlComponent,
    DropDownWrapperComponent,
    DtoTypeCellComponent,
    MultiselectCellComponent,
    MultiselectWrapperComponent,
    EntityReferenceInputComponent,
    OverlayComponent,
    ColHeaderComponent,
    GridInputComponent,
    TabContainerComponent
  ],
  imports: [
    CommonModule,
    PermissionsModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    DialogModule,
    ButtonModule,
    RouterModule,
    ConfirmDialogModule,
    MultiSelectModule,
    CalendarModule,
    OverlayPanelModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
    PanelModule,
    TabViewModule,
    EditorModule,
    CardModule,
    ChartModule,
    FileUploadModule,
    FileSaverModule,
    IconPickerModule,
    DirectivesModule,
    ProgressSpinnerModule,
    MiscModule,
    PickListModule,
    ColorPickerModule,
    InputNumberModule,
    RadioButtonModule,
    EditComponentsModule,
    AutoCompleteModule,
    FieldsetModule,
    ToggleButtonModule
    // SharedComponentsModule
  ],
  exports: [EntityViewComponent, DynamicTableComponent, MultilineEditorComponent]
})
export class DtoModule {}
